import React from 'react';
import StatusBadge from '../../../Components/Common/StatusBadge';
import { getStatusMeta } from '../utils/negotiationStatus';

// `code` is a BE statusLabel (package / cargo / partner) or a derived
// WAITING_FOR_* code from getPartnerDisplayStatus.
const NegotiationStatusBadge = ({ code, size }) => {
  if (!code) return <span className='text-muted'>-</span>;
  const { label, tone } = getStatusMeta(code);
  return <StatusBadge tone={tone} label={label} size={size} />;
};

export default NegotiationStatusBadge;
